import type * as React from 'react';
const SvgIcoBubble = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle fill="currentColor" cx={12} cy={12} r={10} />
  </svg>
);
export default SvgIcoBubble;
